import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { costWith, costWithout } from '../data/content';
export function CostOfInaction() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-34" data-mp="2pz0y27ssp9yg">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-35" data-mp="2uxklydqy8vtg">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-36" data-mp="2zwnif9sv5tpt">
          <ScaleIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-37" data-mp="34txeh8ard3mm" />
          ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mx-auto mt-12 max-w-narrow overflow-x-auto rounded-2xl ring-1 ring-blue-100" data-id="element-38" data-mp="3dntqhua7kzob">
          <table className="w-full min-w-[30rem] border-collapse text-left" data-id="element-39" data-mp="3inodhmqv5543">
            <caption className="sr-only" data-id="element-40" data-mp="3nmrjpaikxhdn">Comparación entre seguir sin el sistema y usar el sistema</caption>
            <thead data-id="element-41" data-mp="3sl2txmcsdtwe">
              <tr className="bg-blue-50" data-id="element-42" data-mp="3smnpnfau7ivu">
                <th scope="col" className="px-5 py-4 font-display text-sm font-extrabold text-blue-900/60 md:px-6" data-id="element-43" data-mp="3sji1c2a18l16">
                  Sin el sistema
                </th>
                <th scope="col" className="bg-blue-100 px-5 py-4 font-display text-sm font-extrabold text-blue-800 md:px-6" data-id="element-44" data-mp="39glgvy8aer5v">
                  Con el sistema
                </th>
              </tr>
            </thead>
            <tbody data-id="element-45" data-mp="30ihw5454lyf4">
              {costWithout.map((item, index) => <tr key={item} className="border-t border-blue-100 bg-white" data-id="element-46" data-mp="10iea6w17soe" data-mpi={index}>
                  <td className="px-5 py-4 text-blue-900/60 md:px-6" data-id="element-47" data-mp="3s7csl6fqytnf">{item}</td>
                  <td className="bg-blue-50 px-5 py-4 font-semibold text-blue-800 md:px-6" data-id="element-48" data-mp="3ngwc1dgmqrwu">{costWith[index]}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mx-auto mt-12 max-w-2xl font-display text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-49" data-mp="jrszq8iznd8w">
          La próxima semana puede ser diferente.
        </p>
      </div>
    </section>;
}